import { html } from 'lit';
import { __ } from 'i18n';
import { _converse, api } from '@converse/headless';
import { CustomElement } from 'shared/components/element.js';

class RegisterLink extends CustomElement {
    render() {
        // Registration from the login page has been intentionally hidden.
        return '';
    }

    shouldShow() {
        return (
            api.settings.get('allow_registration') &&
            !api.settings.get('auto_login') &&
            _converse.pluggable.plugins['converse-register'].enabled(_converse)
        );
    }
}

api.elements.define('converse-register-link', RegisterLink);

export default RegisterLink;
